import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const LogoComunicar = ({ height = 40 }) => (
  <img 
    src="/images/logo_centro.png" 
    alt="Comunicar" 
    style={{ height: height, width: 'auto', display: 'block' }}
  />
);

const SECCIONES = [
  { id: 'terminos',   label: 'Terminos y Condiciones' },
  { id: 'privacidad', label: 'Politica de Privacidad' },
  { id: 'cookies',    label: 'Politica de Cookies' },
];

const FECHA = '20 de abril de 2026';
const EMPRESA = 'COMUNICAR DESARROLLO Y LENGUAJE EIRL';
const RUC = '20615646939';
const EMAIL = 'terapias.comunicar@gmail.com';
const WEB = 'centrocomunicar.com';

export default function Legal() {
  const [seccion, setSeccion] = useState('terminos');

  return (
    <div className="lg-page">

      {/* NAV */}
      <nav className="lg-nav">
        <Link to="/" className="lg-nav__logo"><LogoComunicar height={42}/></Link>
        <Link to="/" className="lg-nav__back">← Volver al inicio</Link>
      </nav>

      {/* HEADER */}
      <div className="lg-header">
        <div className="lg-header__inner">
          <p className="lg-header__label">Documentos legales</p>
          <h1>Legal y <em>Privacidad</em></h1>
          <p className="lg-header__sub">
            {EMPRESA} | RUC: {RUC} | Ultima actualizacion: {FECHA}
          </p>
        </div>
      </div>

      {/* TABS */}
      <div className="lg-tabs">
        {SECCIONES.map(function(s) {
          return (
            <button
              key={s.id}
              className={'lg-tab ' + (seccion === s.id ? 'lg-tab--active' : '')}
              onClick={function() { setSeccion(s.id); window.scrollTo({top:0,behavior:'smooth'}); }}
            >
              {s.label}
            </button>
          );
        })}
      </div>

      <div className="lg-body">

        {/* ══ TERMINOS Y CONDICIONES ══ */}
        {seccion === 'terminos' && (
          <div className="lg-doc">
            <h2>Terminos y Condiciones de Uso</h2>
            <p className="lg-fecha">Vigente desde: {FECHA}</p>

            <div className="lg-seccion">
              <h3>1. Identificacion del titular</h3>
              <p>El presente sitio web <strong>{WEB}</strong> es operado por <strong>{EMPRESA}</strong>, con RUC <strong>{RUC}</strong>, constituida bajo las leyes de la Republica del Peru. Para cualquier consulta legal: <a href={'mailto:' + EMAIL}>{EMAIL}</a>.</p>
            </div>

            <div className="lg-seccion">
              <h3>2. Aceptacion de los terminos</h3>
              <p>El acceso y uso del sitio web implica la aceptacion plena y sin reservas de los presentes Terminos y Condiciones. Si no estas de acuerdo con alguno de los terminos aqui establecidos, debes abstenerte de utilizar el sitio.</p>
            </div>

            <div className="lg-seccion">
              <h3>3. Descripcion de los servicios</h3>
              <p>Centro Comunicar ofrece los siguientes servicios a traves de su plataforma digital:</p>
              <ul>
                <li>Formaciones y cursos especializados en lenguaje y comunicacion (grabados y en vivo)</li>
                <li>Materiales terapeuticos descargables (imprimibles, kits, juegos)</li>
                <li>Acceso a un Aula Virtual basada en Moodle</li>
                <li>Contenido gratuito y boletin informativo mensual</li>
                <li>Programa de fidelidad por puntos</li>
              </ul>
            </div>

            <div className="lg-seccion">
              <h3>4. Condiciones de compra</h3>
              <p>Al realizar una compra en nuestra plataforma, el usuario acepta las siguientes condiciones:</p>
              <ul>
                <li>Los precios mostrados incluyen impuestos aplicables segun la legislacion peruana.</li>
                <li>Los recursos digitales y cursos adquiridos son de uso personal e intransferible.</li>
                <li>No se permite la redistribucion, reventa, copia o reproduccion de los materiales adquiridos.</li>
                <li>El acceso a cursos grabados es ilimitado en el tiempo desde la fecha de activacion.</li>
                <li>Los cursos en vivo tienen fecha de inicio determinada y no garantizan repeticion.</li>
              </ul>
            </div>

            <div className="lg-seccion">
              <h3>5. Medios de pago</h3>
              <p>Aceptamos los siguientes metodos de pago:</p>
              <ul>
                <li>Tarjetas de credito y debito (Visa, Mastercard) a traves de la pasarela Izipay</li>
                <li>Yape y transferencias bancarias (validacion en 24 horas habiles)</li>
              </ul>
              <p>Los pagos son procesados de forma segura. No almacenamos datos de tarjetas de credito.</p>
            </div>

            <div className="lg-seccion">
              <h3>6. Politica de cancelacion y reembolso</h3>
              <p>Dado que nuestros productos son de naturaleza digital y de acceso inmediato, no se realizan reembolsos una vez activado el acceso al curso o descargado el material, salvo en los siguientes casos:</p>
              <ul>
                <li>El producto no corresponde a lo descrito en la plataforma.</li>
                <li>Se produjo un cobro duplicado o error en el procesamiento del pago.</li>
                <li>El acceso al contenido no puede ser habilitado por causas imputables a Centro Comunicar.</li>
              </ul>
              <p>Para solicitar un reembolso, el usuario debe contactar a <a href={'mailto:' + EMAIL}>{EMAIL}</a> dentro de los 7 dias calendario siguientes a la compra, adjuntando el comprobante de pago.</p>
            </div>

            <div className="lg-seccion">
              <h3>7. Propiedad intelectual</h3>
              <p>Todos los contenidos del sitio web, incluyendo textos, imagenes, videos, materiales descargables, marcas y logotipos, son propiedad de {EMPRESA} o de sus autores licenciantes, y estan protegidos por la legislacion peruana e internacional sobre propiedad intelectual.</p>
              <p>Queda expresamente prohibida la reproduccion, distribucion o comunicacion publica de cualquier contenido sin autorizacion previa y por escrito.</p>
            </div>

            <div className="lg-seccion">
              <h3>8. Limitacion de responsabilidad</h3>
              <p>Centro Comunicar no se hace responsable de:</p>
              <ul>
                <li>Interrupciones temporales del servicio por mantenimiento o causas tecnicas.</li>
                <li>El uso inadecuado que el usuario haga de los materiales adquiridos.</li>
                <li>Danos indirectos derivados del uso del sitio web.</li>
              </ul>
            </div>

            <div className="lg-seccion">
              <h3>9. Libro de Reclamaciones</h3>
              <p>Conforme al Articulo 150 del Codigo de Proteccion y Defensa del Consumidor (Ley N 29571), contamos con un Libro de Reclamaciones virtual disponible en:</p>
              <Link to="/libro-reclamaciones" className="lg-link-btn">Acceder al Libro de Reclamaciones</Link>
            </div>

            <div className="lg-seccion">
              <h3>10. Legislacion aplicable</h3>
              <p>Los presentes Terminos y Condiciones se rigen por la legislacion de la Republica del Peru. Para cualquier controversia, las partes se someten a los tribunales competentes de la ciudad de Lima.</p>
            </div>

            <div className="lg-seccion">
              <h3>11. Modificaciones</h3>
              <p>Centro Comunicar se reserva el derecho de modificar los presentes Terminos y Condiciones en cualquier momento. Los cambios seran publicados en esta pagina con la fecha de actualizacion. El uso continuado del sitio implica la aceptacion de los terminos actualizados.</p>
            </div>
          </div>
        )}

        {/* ══ POLITICA DE PRIVACIDAD ══ */}
        {seccion === 'privacidad' && (
          <div className="lg-doc">
            <h2>Politica de Privacidad y Proteccion de Datos Personales</h2>
            <p className="lg-fecha">Vigente desde: {FECHA}</p>

            <div className="lg-seccion">
              <h3>1. Responsable del tratamiento</h3>
              <p><strong>{EMPRESA}</strong>, RUC <strong>{RUC}</strong>, es el responsable del tratamiento de los datos personales que se recogen a traves del sitio web <strong>{WEB}</strong>, en cumplimiento de la Ley N 29733 - Ley de Proteccion de Datos Personales del Peru y su Reglamento (D.S. N 003-2013-JUS).</p>
            </div>

            <div className="lg-seccion">
              <h3>2. Datos personales que recopilamos</h3>
              <p>Recopilamos los siguientes tipos de datos personales:</p>
              <ul>
                <li><strong>Datos de registro:</strong> nombre, apellidos, correo electronico, telefono.</li>
                <li><strong>Datos de compra:</strong> historial de pedidos, metodo de pago (no almacenamos datos de tarjeta).</li>
                <li><strong>Datos de uso:</strong> accesos al aula virtual, descargas realizadas, puntos acumulados.</li>
                <li><strong>Datos de contacto:</strong> mensajes enviados a traves del formulario de atencion al cliente.</li>
                <li><strong>Datos tecnicos:</strong> direccion IP, tipo de navegador, paginas visitadas (via cookies).</li>
              </ul>
            </div>

            <div className="lg-seccion">
              <h3>3. Finalidad del tratamiento</h3>
              <p>Los datos personales son tratados para las siguientes finalidades:</p>
              <ul>
                <li>Gestion de la cuenta de usuario y acceso a los servicios contratados.</li>
                <li>Procesamiento y seguimiento de pedidos y pagos.</li>
                <li>Envio de comunicaciones relacionadas con los servicios contratados.</li>
                <li>Envio del boletin informativo (solo si el usuario consiente expresamente).</li>
                <li>Atencion de consultas, reclamos y quejas.</li>
                <li>Mejora de los servicios y analisis estadistico anonimizado.</li>
                <li>Cumplimiento de obligaciones legales y tributarias.</li>
              </ul>
            </div>

            <div className="lg-seccion">
              <h3>4. Base legal del tratamiento</h3>
              <p>El tratamiento de datos personales se realiza bajo las siguientes bases legales:</p>
              <ul>
                <li>Ejecucion de un contrato (compra de cursos o materiales).</li>
                <li>Consentimiento expreso del titular (boletin, cookies no esenciales).</li>
                <li>Obligacion legal (emision de comprobantes de pago, Libro de Reclamaciones).</li>
                <li>Interes legitimo (seguridad del sistema, prevencion del fraude).</li>
              </ul>
            </div>

            <div className="lg-seccion">
              <h3>5. Conservacion de datos</h3>
              <p>Los datos personales se conservan durante el tiempo necesario para cumplir con la finalidad para la que fueron recogidos y durante los plazos legales aplicables (5 anos para datos contables y tributarios segun la legislacion peruana).</p>
            </div>

            <div className="lg-seccion">
              <h3>6. Comparticion de datos con terceros</h3>
              <p>No vendemos ni cedemos datos personales a terceros. Podemos compartir datos con:</p>
              <ul>
                <li><strong>Pasarelas de pago</strong> (Izipay): para el procesamiento seguro de transacciones.</li>
                <li><strong>Plataforma Moodle</strong>: para la gestion del Aula Virtual.</li>
                <li><strong>Proveedores de email</strong>: para el envio de comunicaciones.</li>
                <li><strong>SUNAT e INDECOPI</strong>: cuando sea requerido por obligacion legal.</li>
              </ul>
              <p>Todos los terceros con los que trabajamos estan obligados contractualmente a tratar los datos de forma confidencial y segura.</p>
            </div>

            <div className="lg-seccion">
              <h3>7. Derechos del titular</h3>
              <p>Conforme a la Ley N 29733, el titular de los datos personales tiene derecho a:</p>
              <ul>
                <li><strong>Acceso:</strong> conocer que datos tenemos sobre usted.</li>
                <li><strong>Rectificacion:</strong> corregir datos inexactos o incompletos.</li>
                <li><strong>Cancelacion:</strong> solicitar la eliminacion de sus datos.</li>
                <li><strong>Oposicion:</strong> oponerse al tratamiento de sus datos para determinadas finalidades.</li>
              </ul>
              <p>Para ejercer estos derechos, envie un correo a <a href={'mailto:' + EMAIL}>{EMAIL}</a> indicando su solicitud y adjuntando copia de su documento de identidad.</p>
            </div>

            <div className="lg-seccion">
              <h3>8. Seguridad de los datos</h3>
              <p>Implementamos medidas tecnicas y organizativas para proteger los datos personales frente a accesos no autorizados, perdida o destruccion, incluyendo cifrado SSL, control de accesos y copias de seguridad periodicas.</p>
            </div>

            <div className="lg-seccion">
              <h3>9. Contacto</h3>
              <p>Para cualquier consulta sobre el tratamiento de sus datos personales, puede contactarnos en: <a href={'mailto:' + EMAIL}>{EMAIL}</a>.</p>
            </div>
          </div>
        )}

        {/* ══ POLITICA DE COOKIES ══ */}
        {seccion === 'cookies' && (
          <div className="lg-doc">
            <h2>Politica de Cookies</h2>
            <p className="lg-fecha">Vigente desde: {FECHA}</p>

            <div className="lg-seccion">
              <h3>1. Que son las cookies</h3>
              <p>Las cookies son pequenos archivos de texto que se almacenan en el dispositivo del usuario cuando visita un sitio web. Permiten que el sitio recuerde informacion sobre la visita, lo que facilita la navegacion y mejora la experiencia del usuario.</p>
            </div>

            <div className="lg-seccion">
              <h3>2. Tipos de cookies que utilizamos</h3>
              <div className="lg-tabla">
                <div className="lg-tabla__head">
                  <span>Tipo</span><span>Finalidad</span><span>Duracion</span>
                </div>
                {[
                  ['Sesion / autenticacion', 'Mantener la sesion iniciada del usuario', 'Sesion'],
                  ['Preferencias', 'Recordar configuraciones del usuario', '30 dias'],
                  ['Analiticas', 'Medir el uso del sitio de forma anonima', '12 meses'],
                  ['Funcionales', 'Carrito, puntos y estado de compras', 'Sesion'],
                ].map(function(row) {
                  return (
                    <div key={row[0]} className="lg-tabla__row">
                      <span><strong>{row[0]}</strong></span>
                      <span>{row[1]}</span>
                      <span>{row[2]}</span>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="lg-seccion">
              <h3>3. Cookies de terceros</h3>
              <p>Algunas cookies pueden ser instaladas por servicios de terceros que utilizamos, como la plataforma Moodle para el Aula Virtual. Estos terceros tienen sus propias politicas de privacidad.</p>
            </div>

            <div className="lg-seccion">
              <h3>4. Como gestionar las cookies</h3>
              <p>Puedes configurar tu navegador para rechazar o eliminar las cookies. Sin embargo, algunas funciones del sitio pueden no estar disponibles si las cookies esenciales son desactivadas. Para gestionar las cookies en tu navegador:</p>
              <ul>
                <li><strong>Chrome:</strong> Configuracion - Privacidad y seguridad - Cookies</li>
                <li><strong>Firefox:</strong> Opciones - Privacidad y seguridad - Cookies</li>
                <li><strong>Safari:</strong> Preferencias - Privacidad - Cookies</li>
                <li><strong>Edge:</strong> Configuracion - Cookies y permisos del sitio</li>
              </ul>
            </div>

            <div className="lg-seccion">
              <h3>5. Actualizaciones de esta politica</h3>
              <p>Podemos actualizar esta Politica de Cookies periodicamente. Los cambios seran publicados en esta pagina. El uso continuado del sitio implica la aceptacion de la politica actualizada.</p>
            </div>
          </div>
        )}

      </div>

      {/* FOOTER MINI */}
      <div className="lg-footer">
        <div className="lg-footer__inner">
          <LogoComunicar height={30}/>
          <p>{EMPRESA} | RUC: {RUC} | {WEB}</p>
          <div className="lg-footer__links">
            <Link to="/atencion-cliente">Atencion al cliente</Link>
            <Link to="/libro-reclamaciones">Libro de reclamaciones</Link>
            <Link to="/">Volver al inicio</Link>
          </div>
        </div>
      </div>

    </div>
  );
}